import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { searchUniverse } from '@/lib/api/universe'
import { normalizeQuery } from '@/lib/compute/universe'
import type { EntityKind } from '@/lib/types/universe'

/** Explorer search across the given kinds; an empty query browses the first rows by name. Disabled when no kinds are given. */
export function useUniverseSearch(q: string, kinds: EntityKind[]) {
  return useQuery({
    queryKey: ['universe', 'search', kinds, normalizeQuery(q)],
    queryFn: () => searchUniverse(q, kinds),
    enabled: kinds.length > 0,
    placeholderData: keepPreviousData,
    // Directory data changes rarely; 30s avoids refetching while the user types back and forth.
    staleTime: 30_000,
  })
}
